// import heroImage from './../assets/img/totalSolar-1.jpeg'
// import monterrasaz from './../assets/img/monterrazas-de-cebu.png'
// import kima from './../assets/img/kima-glass.webp'
// import nissan from './../assets/img/nissan-white.png'
// import mandaueFoam from './../assets/img/client_mandaueFoam.avif'
// import aficionado from './../assets/img/client_aficionado.png'
// import solarbg from './../assets/img/solarbg.png'
// import homeVideo from "./../assets/img/vidTotalSolar.mp4"
// import servicesIcon1 from './../assets/img/engineering-plan.svg'
// import servicesIcon2 from './../assets/img/solar-charging.svg'

import { BoltIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { HeroProjectsSlider } from './HeroProjectsSlider'
import { useRef, useState } from 'react'
import { CommonTransition } from '../utils/CommonTransition'
import CountUp from 'react-countup'
import { useIsInViewport } from '../utils/CustomHooks'
import { WhyGoSolar } from './WhyGoSolar'
import { ChevronDoubleRightIcon } from '@heroicons/react/24/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleChevronRight } from '@fortawesome/free-solid-svg-icons'
import { ASSETS_URL } from '../utils/constants'

const sm = ASSETS_URL + 'sm.png'
const cebuOceanPark = ASSETS_URL + 'manilaOceanPark.png'
const heroImage = ASSETS_URL + 'totalSolar-1.jpeg'
const monterrasaz = ASSETS_URL + 'monterrazas-de-cebu.png'
const kima = ASSETS_URL + 'kima-glass.webp'
const nissan = ASSETS_URL + 'nissan-white.png'
const mandaueFoam = ASSETS_URL + 'client_mandaueFoam.avif'
const aficionado = ASSETS_URL + 'client_aficionado.png'
const solarbg = ASSETS_URL + 'solarbg.png'

const deca = ASSETS_URL + 'client_deca.png'
const gaisano = ASSETS_URL + 'client_gaisano.png'
const hispeed = ASSETS_URL + 'client_hispeed.png'
const jmc = ASSETS_URL + 'client_jmc.png'
const liteblock = ASSETS_URL + 'client_liteblock.png'
const pwri = ASSETS_URL + 'client_pwri.png'
const zesto = ASSETS_URL + 'client_zesto.png'

const homeVideo = ASSETS_URL + 'vidTotalSolar.mp4'
const servicesIcon1 = ASSETS_URL + 'engineering-plan.svg'
const servicesIcon2 = ASSETS_URL + 'solar-charging.svg'

const BoltIconBullet = () =>{
    return <>
        <BoltIcon className='h-4 w-4 text-[#2ba837] shrink-0'/>
    </>
}

const DoubleArrowBullet = () =>{
  return <>
      <ChevronDoubleRightIcon className='h-4 w-4 text-[#2ba837]'/>
  </>
}


function Hero() {
    return <>
      <HeroProjectsSlider />
      <div className="hidden w-full min-h-[600px] relative flex justify-center">
        <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph'" className="w-full h-full absolute bg-no-repeat object-cover" src={heroImage}/>
        <div className='relative w-[80%] flex flex-col'>
            <p className="mt-20 font-bold text-3xl text-[#ffba00] text-left w-full md:w-[60%]">Total Solar Installation is committed to deliver the top-tier Solar solutions for your Home and Business Sites. </p>
            <p className="font-bold text-base text-white text-left w-full md:w-[55%]">Embrace a sustainable future, save on energy costs, and make a positive impact on the environment. </p>
            <p className='text-white text-left w-full md:w-[50%]'>With our expertise in the solar energy industry, we strive to bring you the most efficient and cost-effective solar solutions available.</p>
            <Link to={'/about'} className="bg-[#ffba00] px-6 py-3 mt-2 hover:border-dotted rounded-full text-sm font-bold w-full sm:w-[250px] text-black">Learn more</Link>

            
            
        </div>
      </div>
      <TrustedBy />
      <ServicesOffered />
      <WhyGoSolar />
      <TotalSolarVideo />
      <ProjectSummary/>
      
    </>
  }


  const TrustedBy = () => {
    return <>
        <div className="font-[Montserrat] flex flex-col items-center p-6 mt-8">
            <p className="w-[70%] text-xl sm:text-3xl text-[#f7f7f7] font-bold hover:text-[#4CB117]">Trusted by many homes and business sites all over the Philippines</p>
            <div className="p-6 flex flex-wrap flex-col md:flex-row items-center justify-center space-y-2">
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[80px] object-contain w-[200px] " src={sm}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[80px] object-contain w-[180px] md:pr-10" src={monterrasaz}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[80px] object-contain w-[180px] " src={kima}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[70px] object-contain w-[200px]" src={nissan}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[70px] object-contain w-[200px]" src={mandaueFoam}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[50px] object-contain w-[200px]" src={aficionado}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[50px] object-contain w-[200px]" src={liteblock}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[80px] object-contain w-[200px] " src={deca}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[80px] object-contain w-[180px] md:pr-10" src={gaisano}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[80px] object-contain w-[180px] " src={hispeed}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[70px] object-contain w-[200px]" src={jmc}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[70px] object-contain w-[200px]" src={pwri}/>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="h-[50px] object-contain w-[200px]" src={zesto}/>
                {/* <img className="h-[70px] object-contain w-[200px]" src={theRise}/> */}
                
            </div>
        </div>
    </>
  }

  const ServicesOffered = () => {
    return <>
    <div className="font-[Montserrat] bg-[#F3F3F3] w-full h-full flex justify-center items-start text-white pt-5 pb-8">
      <div className='w-[80%] flex flex-col'>
        <p className="text-3xl sm:text-5xl text-[#4CB117] font-bold text-center mt-4 pb-4">Services Offered</p>
        
        <div className='flex flex-col md:flex-row space-between relative h-auto md:h-[375px] overflow-hidden'>
          <ServicesOfferedItem 
            bgColor={'bg-white'}
            position={'md:left-0'}
            renderTitleAndLogo={() => <>
              <ServicesOfferedTitle bgColor={'bg-white font-bold hover:text-[#4CB117] text-[0.75rem] sm:whitespace-nowrap'}>
                <img alt="'total solar installation','total solar installation by rb gonzales opc', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={servicesIcon1} className='h-10 sm:h-20 w-10 sm:w-20'/>
                SOLAR PV SYSTEM DESIGN
              </ServicesOfferedTitle>
            </>}>
              <div>
                <div className='font-bold py-1 flex sm:pt-10'><BoltIconBullet/>DEVELOPMENT</div>
                <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>SCHEMATIC DESIGN</div>
                <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>CONSTRUCTION DRAWINGS</div>
                <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>PROJECT COSTINGS</div>
              </div>
          </ServicesOfferedItem>

          <ServicesOfferedItem 
            bgColor={'bg-white sm:bg-[#f3f3f3] mt-2 sm:mt-0'}
            position={'md:right-0'}
            logoToLeft
            renderTitleAndLogo={() => <>
              <ServicesOfferedTitle bgColor={'bg-white sm:bg-[#f3f3f3] font-bold text-[0.75rem] hover:text-[#4CB117]'}>
                <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={servicesIcon2} className='h-10 w-10 sm:h-20 sm:w-20 '/>
                <span className='sm:whitespace-nowrap'>SOLAR PV SYSTEM CONSTRUCTION</span>
              </ServicesOfferedTitle>
            </>}>
            <div className='flex flex-col'>
              <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>PERMIT PROCESSING</div>
              <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>PROCUREMENT</div>
              <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>CONSTRUCTION</div>
              <div className='font-bold py-1 flex pt-3'><BoltIconBullet/>TESTING AND COMMISSIONING</div>
            </div>  
            
          </ServicesOfferedItem>
        </div>
        <Link to={"services"} className="mt-3 text-[#4CB117] w-full hover:text-[#1E1C1C] text-l sm:text-xl font-bold cursor-pointer flex items-center justify-center" >View All Services <FontAwesomeIcon icon={faCircleChevronRight} className='h-4 w-4 ml-2'/></Link>
      </div>
    </div>
    </>
  }
  
  const ServicesOfferedItem = ({bgColor, position, logoToLeft, renderTitleAndLogo, children}) => {

    const [isHovered, setIsHovered] = useState(false)
    return <>
    <div onMouseEnter={()=>setIsHovered(true)} 
        onMouseLeave={()=>setIsHovered(false)} 
        className={`${bgColor} text-gray-500 
                    flex flex-row sm:flex-col ${logoToLeft ? 'md:flex-row':'md:flex-row-reverse'} justify-center
                    w-full md:w-[50%] md:absolute md:top-0 ${position}
                    translate transform duration-[500ms] shrink-[2]
                    hover:w-full hover:text-[#4CB117] hover:z-[1]
                    ease-in-out`}>
      <div className='w-1/2 sm:w-auto sm:px-12'>
      {
        renderTitleAndLogo && renderTitleAndLogo()
      }
      </div>
      <div className='w-1/2 sm:hidden text-[0.70rem] text-left py-3'>
        {
          children
        }
      </div>
      <CommonTransition open={isHovered} durationEnter={'duration-[1500ms]'} durationExit={'duration-0'}>
      <div className={`${bgColor} text-black text-sm text-justify grow px-8 hidden sm:flex items-center justify-center`}>
        {
          children
        }
        </div>
      </CommonTransition>
      
    </div>
    </>
  }
  const ServicesOfferedTitle = ({bgColor,children}) => {
    return <li className={`${bgColor} flex flex-col justify-center items-center p-5 w-full sm:h-[350px]`}>{children}</li>
  }


  const TotalSolarVideo = () => {
    return <>
    <div className="bg-[#212121] font-[Montserrat] w-full h-auto flex flex-col items-start text-white">
        <video className='w-full' src={homeVideo} autoPlay loop muted />
    </div>
    </>
  }

  const ProjectSummary = () => {
    const itemRef = useRef(null);
    const isInViewport = useIsInViewport(itemRef);

    return <>
        <div ref={itemRef} className="w-full font-[Montserrat] flex flex-col items-center p-10 relative">
          
          <CommonTransition open={isInViewport}>
            <div className='z-[1]'>
              <p className="w-full text-center mt-4 mb-3 text-[#4CB117]  text-3xl sm:text-5xl font-extrabold hover:text-[#f7f7f7]">Projects</p>
              <p className="w-full text-m text-[#f7f7f7] font-bold hover:text-[#4CB117]">Total Solar has provided and installed solar solutions to homes and business sites all over the Philippines</p>
              <div className="w-full p-6 flex flex-col md:flex-row items-center">
                
                <div className="w-full text-xl sm:text-2xl text-[#f7f7f7] font-bold hover:text-[#4CB117]"><div className='text-3xl sm:text-5xl'><CountUp end={55} duration={3} /> </div>Completed Projects</div>
                <div className="w-full text-xl sm:text-2xl text-[#f7f7f7] font-bold hover:text-[#4CB117]"><div className='text-3xl sm:text-5xl'><CountUp end={18}  duration={3} /></div> Pipeline Projects</div>  
              </div>
              <div>
                <Link 
                  className='text-[#f7f7f7] hover:text-[#4CB117] font-bold rounded-lg p-3 flex justify-center items-center'
                  to={'/projects'}>
                  View Projects <FontAwesomeIcon icon={faCircleChevronRight} className='h-4 w-4 ml-2'/></Link>
              </div>
            </div>
          </CommonTransition>
          <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={solarbg} className='absolute opacity-85 h-full w-full top-0 right-0 object-cover' />
        </div>
    </>
  }
  
  export default Hero;


  